// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__4ZGGA","toggle":"Nav_toggle__H45-b","active":"Nav_active__CoeOF"};